@if (timeOut()) {
  <div class="widget container">
    <app-timeout></app-timeout>
  </div>
} @else if (loading()) {
  <div class="flex widget justify-content-center align-items-center container">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  @if (assetHierarchy()) {
    <ngx-simplebar [options]="{ autoHide: false }" class="flex flex-column widget container pt-5 pb-5 assetHierarchy">
      @if (statusMode()) {
        <div class="selectContainer p-2">
          <p-selectButton
            [options]="displayedItemsOptions"
            [(ngModel)]="displayedItems"
            optionValue="value"
            allowEmpty="false"
          >
            <ng-template #item let-item>
              {{ item.label | translate }}
            </ng-template>
          </p-selectButton>
        </div>
      }
      <div
        class="pr-3 pl-3 flex align-items-end justify-content-between gap-2 w-full pointer select-none hover:surface-200 p-2"
        (click)="toggleAllExpanded()"
      >
        <span>
          @if (allCollapsed()) {
            {{ "hierarchy_widget.collapse_all" | translate }}
          } @else {
            {{ "hierarchy_widget.expand_all" | translate }}
          }
        </span>
        @if (allCollapsed()) {
          <app-svg-icon class="expandIcon" iconName="arrow_up" iconColor="primary" iconSize="xs"></app-svg-icon>
        } @else {
          <app-svg-icon class="expandIcon" iconName="arrow_down" iconColor="primary" iconSize="xs"></app-svg-icon>
        }
      </div>
      <ng-container *ngTemplateOutlet="assetItem; context: { list: assetHierarchy() }"></ng-container>
    </ngx-simplebar>

    <ng-template #assetItem let-list="list">
      @for (asset of list; track asset.id) {
        @if (displayedItems === "all" || asset.severity === "MAJOR" || asset.severity === "CRITICAL") {
          <div
            [ngClass]="{
              selected: asset.selected && itemsSelectable(),
              itemsSelectable: itemsSelectable(),
            }"
            (click)="onAssetClick(asset)"
            class="hierarchyItem"
          >
            <div class="assetItem flex justify-content-between align-items-center pr-3 pl-3">
              <div
                class="flex align-items-center gap-3 w-11"
                [ngClass]="asset.assetType === 'GATE_SYSTEM' ? 'w-full' : 'w-11'"
              >
                <ng-container
                  *ngTemplateOutlet="
                    icons;
                    context: {
                      assetType: asset.assetType,
                      selected: asset.selected,
                    }
                  "
                ></ng-container>
                @if (statusMode() && asset.assetType !== "TENANT") {
                  @if (asset.assetType === "GATE_SYSTEM") {
                    <span class="dot" [ngClass]="asset.severity ? asset.severity : 'UNKNOWN'"></span>
                  } @else if (asset.severity !== "UNKNOWN" && asset.core) {
                    <!-- Only show in case it is not a gate system and severity is not unknown otherwise dont render anything -->
                    <span class="dot" [ngClass]="asset.severity"></span>
                  }
                }

                <span class="assetLabel" [pTooltip]="asset.label" showDelay="200"> {{ asset.label }}</span>
              </div>
              @if (asset.assetType === "GATE_SYSTEM" || asset.children.length === 0) {
                <!-- spacer because GATE doesnt have expand arrow: -->
                <span></span>
              } @else {
                @if (asset.expanded) {
                  <app-svg-icon
                    class="expandIcon"
                    (click)="toggleExpand(asset, $event)"
                    iconName="arrow_up"
                    [iconColor]="asset.selected && itemsSelectable() ? 'secondary' : 'primary'"
                    iconSize="xs"
                  ></app-svg-icon>
                } @else {
                  <app-svg-icon
                    class="expandIcon"
                    (click)="toggleExpand(asset, $event)"
                    iconName="arrow_down"
                    [iconColor]="asset.selected && itemsSelectable() ? 'secondary' : 'primary'"
                    iconSize="xs"
                  ></app-svg-icon>
                }
              }
            </div>
          </div>
        }
        @if (asset.children && asset.children !== null && asset.children.length > 0 && asset.expanded) {
          <ng-container *ngTemplateOutlet="assetItem; context: { list: asset.children }"></ng-container>
        }
      }
    </ng-template>

    <ng-template #icons let-assetType="assetType" let-selected="selected">
      <div class="flex align-items-center">
        @switch (assetType) {
          @case ("TENANT") {
            <app-svg-icon
              iconName="customer"
              [iconColor]="selected && itemsSelectable() ? 'secondary' : 'primary'"
              [iconSize]="iconsSize"
            ></app-svg-icon>
          }
          @case ("CUSTOMER") {
            <span
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
              }"
              class="hierarchyLine"
              [ngClass]="{ selected: selected && itemsSelectable() }"
            ></span>

            <app-svg-icon
              iconName="customer"
              [iconColor]="selected && itemsSelectable() ? 'secondary' : 'primary'"
              [iconSize]="iconsSize"
            ></app-svg-icon>
          }
          @case ("LOCATION") {
            <span
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
              }"
              class="hierarchyLine"
              [ngClass]="{ selected: selected && itemsSelectable() }"
            ></span>

            <span class="hierarchyLine" [ngClass]="{ selected: selected && itemsSelectable() }"></span>
            <app-svg-icon
              iconName="location"
              [iconColor]="selected && itemsSelectable() ? 'secondary' : 'primary'"
              [iconSize]="iconsSize"
            ></app-svg-icon>
          }
          @case ("BUILDING") {
            <span
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
              }"
              class="hierarchyLine"
              [ngClass]="{ selected: selected && itemsSelectable() }"
            ></span>

            <span class="hierarchyLine" [ngClass]="{ selected: selected && itemsSelectable() }"></span>
            <span class="hierarchyLine" [ngClass]="{ selected: selected && itemsSelectable() }"></span>
            <app-svg-icon
              iconName="building"
              [iconColor]="selected && itemsSelectable() ? 'secondary' : 'primary'"
              [iconSize]="iconsSize"
            ></app-svg-icon>
          }
          @case ("GATE_SYSTEM") {
            <span
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
              }"
              class="hierarchyLine"
              [ngClass]="{ selected: selected && itemsSelectable() }"
            ></span>

            <span class="hierarchyLine" [ngClass]="{ selected: selected && itemsSelectable() }"></span>
            <span class="hierarchyLine" [ngClass]="{ selected: selected && itemsSelectable() }"></span>
            <span class="hierarchyLine" [ngClass]="{ selected: selected && itemsSelectable() }"></span>
            <app-svg-icon
              iconName="gate-0"
              [iconColor]="selected && itemsSelectable() ? 'secondary' : 'primary'"
              [iconSize]="iconsSize"
            ></app-svg-icon>
          }
          @default {
            <span></span>
          }
        }
      </div>
    </ng-template>

    <ng-template #customerIcons></ng-template>
    <ng-template #locationIcons></ng-template>
    <ng-template #buildingIcons></ng-template>
    <ng-template #gateIcons></ng-template>
  }
}
